import { css } from 'aphrodite';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button } from '../../../../../web/components-v2/Button';
import { CATEGORY_SWATCHES } from '../categoryColors';
import { styleSheet } from '../styles';

interface IProps {
	onChange: (color: string) => void;
	defaultColor: string;
}

export const CategoryCardColors: React.FC<IProps> = ({ onChange, defaultColor }) => {
	const [currentColor, setColor] = useState(defaultColor);

	useEffect(() => {
		if (defaultColor) {
			setColor(defaultColor);
		}
	}, [defaultColor]);

	const handleColorClick = (color: string) => () => {
		setColor(color);
		onChange?.(color);
	};

	return (
		<div className={css(styleSheet.swatches)} role='group' aria-label='Color'>
			{CATEGORY_SWATCHES.map(({ hex, label }) => {
				const isSelected = hex === currentColor;
				return (
					<Button
						key={hex}
						variant='ghost'
						size='icon'
						type='button'
						aria-label={label}
						aria-pressed={isSelected}
						styles={[styleSheet.swatch, isSelected && styleSheet.swatchSelected]}
						onClick={handleColorClick(hex)}
						style={{ backgroundColor: hex }}
					/>
				);
			})}
		</div>
	);
};
